import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from '@/App.vue'
import router from '@/router'
import { useAuthStore } from '@/stores/auth'
import '@/style.css'

/**
 * Мост «транспорт ↔ стор авторизации» здесь **не** собирается — он живёт в
 * setup-е `stores/auth.ts` (`wireBridge`). Направление зависимостей то же
 * самое (`stores → lib`, цикла нет), а стор гарантированно собирает мост при
 * первом же `useAuthStore()` — в том числе в тестах и в любой точке входа,
 * которая не проходит через этот файл.
 *
 * Правило слоёв `types ← lib ← api ← stores ← composables/views` при этом
 * соблюдается: `lib/http.ts` по-прежнему ничего не знает о сторах и получает
 * `setAuthLostHandler` / `setTokensRotatedHandler` инъекцией сверху.
 */
function bootstrap(): void {
  const app = createApp(App)

  app.use(createPinia())

  /**
   * Инстанцируем стор явно между пинией и роутером. Сам он поднялся бы и лениво
   * — на первом `useAuthStore()` внутри гварда, — но тогда момент сборки моста
   * с транспортом зависел бы от того, какой гвард сработал первым. Здесь
   * порядок виден: пиния есть, роутер ещё не начал первую навигацию.
   */
  useAuthStore()

  app.use(router)

  app.mount('#app')
}

bootstrap()
